import produce from 'immer';

import {
  ERRORS_ADD,
  ERRORS_CLEAR,
  TOASTS_ADD,
  TOASTS_REMOVE,
  WIPE,
  CHANGE_STATE,
  SOUNDS_ADD,
  SOUNDS_REMOVE,
  ENABLE_SOUND,
  DISABLE_SOUND,
  ENABLE_REFRESH_CONTACTS,
  DISABLE_REFRESH_CONTACTS,
  INIT_USER,
  CHANGE_USERSMENU_STATE,
  SET_ACCESS_TOKEN,
  REMOVE_ACCESS_TOKEN,
  LOG_IN_FB,
  LOG_OUT_FB,
  ENABLE_DARK_MODE,
  DISABLE_DARK_MODE,
  CHANGE_CHATSMENU_STATE,
  SET_CURRENT_STREAM,
  ENABLE_CLOSE_WARNING,
  DISABLE_CLOSE_WARNING
} from './constants';

export const initialState = {
  errors: [],
  toasts: {
    lastId: 0,
    items : []
  },
  sounds : [],
  menu : {isOpen : false },
  menuChats : {isOpen : true },
  menuUsers : {isOpen : false},
  config: { sonidoActivo: true, contactsRefresh: false, access_token: null, loggedInFB: false, close_warning : true },
  stream : { currentStream : null }
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {

    case INIT_USER:
      if(localStorage.getItem('userSound')){
        draft.config.sonidoActivo = JSON.parse(localStorage.getItem('userSound'));
      }else{
        localStorage.setItem('userSound', draft.config.sonidoActivo.toString());
      }

      if (localStorage.getItem('darkMode')) {
        draft.config.darkMode = JSON.parse(localStorage.getItem('darkMode'));
      } else {
        localStorage.setItem('darkMode', draft.config.sonidoActivo.toString());
      }

      if(localStorage.getItem('contactsRefresh')){
        draft.config.contactsRefresh = JSON.parse(localStorage.getItem('contactsRefresh'));
      }else{
        localStorage.setItem('contactsRefresh', draft.config.contactsRefresh.toString());
      }

      if(localStorage.getItem('access_token')){
        draft.config.access_token = localStorage.getItem('access_token');
      }else{
        localStorage.setItem('access_token', draft.config.access_token);
      }

      if (localStorage.getItem('close_warning')) {
        draft.config.close_warning = JSON.parse(localStorage.getItem('close_warning'))
      } else {
        localStorage.setItem('close_warning', draft.config.close_warning).toString();
      }

    break;

    case ERRORS_ADD:
      draft.errors.push(action.data);
      break;

    case ERRORS_CLEAR:
      draft.errors = initialState.errors;
      break;

    case TOASTS_ADD:
      draft.toasts.items.push(action.data);
      break;

    case TOASTS_REMOVE:
      draft.toasts.items = draft.toasts.items.filter(item => item.id !== action.data);
      break;

    case SET_ACCESS_TOKEN:
        draft.config.access_token = action.token;
        localStorage.setItem('access_token', draft.config.access_token)
    break;

    case REMOVE_ACCESS_TOKEN:
      draft.config.access_token = "";
      localStorage.setItem('access_token', draft.config.access_token)
      break;

    case LOG_IN_FB:
      draft.config.loggedInFB = true;
    break;

    case SET_CURRENT_STREAM:
      draft.stream.currentStream = action.url;
    break;

    case LOG_OUT_FB:
      draft.config.loggedInFB = false;
    break;

    case SOUNDS_ADD:
      draft.sounds.push(action.data);
      break;

    case SOUNDS_REMOVE:
      draft.sounds = draft.sounds.filter(item => item.id !== action.data);
      break;

    case ENABLE_SOUND:
      draft.config.sonidoActivo = true;
      localStorage.setItem('userSound', draft.config.sonidoActivo.toString())
      break;
  
    case ENABLE_CLOSE_WARNING:
      draft.config.close_warning = true;
      localStorage.setItem('close_warning', draft.config.close_warning.toString())
      break;

    case DISABLE_CLOSE_WARNING:
      draft.config.close_warning = false;
      localStorage.setItem('close_warning', draft.config.close_warning.toString())
      break;

    case DISABLE_SOUND:
      draft.config.sonidoActivo = false;
      localStorage.setItem('userSound', draft.config.sonidoActivo.toString())
      break;

    case ENABLE_DARK_MODE:
      draft.config.darkMode = true;
      localStorage.setItem('darkMode', draft.config.darkMode.toString())
      break;

    case DISABLE_DARK_MODE:
      draft.config.darkMode = false;
      localStorage.setItem('darkMode', draft.config.darkMode.toString())
      break;
    
    case ENABLE_REFRESH_CONTACTS:
      draft.config.contactsRefresh = true;
      localStorage.setItem('contactsRefresh', draft.config.contactsRefresh.toString())
      break;
    
    case DISABLE_REFRESH_CONTACTS:
      draft.config.contactsRefresh = false;
      localStorage.setItem('contactsRefresh', draft.config.contactsRefresh.toString())
      break;

    case CHANGE_STATE:
        draft.menu.isOpen = !draft.menu.isOpen;
        break;

    case CHANGE_USERSMENU_STATE:
        draft.menuUsers.isOpen = !draft.menuUsers.isOpen;
        break;  

    case CHANGE_CHATSMENU_STATE:
      draft.menuChats.isOpen = !draft.menuChats.isOpen;
      break;  

    case WIPE:
      draft.errors = initialState.errors;
      draft.toasts = initialState.toasts;
      break;

    default:
  }
});

export default reducer;
